// <ForceRelinkModal> — type "RELINK" to confirm. Triggered from the
// appstore Tenant Settings page; the action revokes Ring App Store
// tokens and unlinks the workspace.

import { useState } from "react";

export interface ForceRelinkModalProps {
  open: boolean;
  busy: boolean;
  onConfirm(): void;
  onCancel(): void;
}

const CONFIRM_PHRASE = "RELINK";

export function ForceRelinkModal({
  open,
  busy,
  onConfirm,
  onCancel,
}: ForceRelinkModalProps): JSX.Element | null {
  const [typed, setTyped] = useState<string>("");

  if (!open) {
    return null;
  }

  const enabled = typed === CONFIRM_PHRASE && !busy;

  return (
    <div
      className="reb-modal__backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="reb-relink-title"
    >
      <div className="reb-modal" role="document">
        <h2 id="reb-relink-title" className="reb-modal__title">
          Force re-link with Ring
        </h2>
        <p>
          This will revoke all Ring App Store tokens for this workspace, sign out every
          active session, and require an administrator to reinstall from the Ring App.
        </p>
        <p>
          Type <code>{CONFIRM_PHRASE}</code> to enable the action.
        </p>
        <input
          autoFocus
          className="reb-input"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          aria-label="Confirmation phrase"
          disabled={busy}
        />
        <div className="reb-modal__actions">
          <button
            type="button"
            className="reb-button"
            onClick={onCancel}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="button"
            className="reb-button reb-button--danger"
            disabled={!enabled}
            onClick={onConfirm}
          >
            {busy ? "Re-linking..." : "Force re-link"}
          </button>
        </div>
      </div>
    </div>
  );
}
